/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */

import {
    Component,
    HostBinding,
    HostListener,
    Input,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';

/**
 * @part track - The background track of the toggle.
 * @part handle - The toggle handle, or knob, used to change the checked state.
 */
@Component({
    selector: 'bazis-toggle',
    template: `
        <div
            class="bazis-toggle__track"
            part="track"
        >
            <div class="bazis-toggle__track-wrapper">
                <div
                    class="bazis-toggle__handle"
                    part="handle"
                ></div>
            </div>
        </div>
        <label [for]="inputId"></label>
        <input
            type="checkbox"
            role="switch"
            [checked]="checked"
            [id]="inputId"
        />
    `,
    styleUrls: ['toggle.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom,
})
export class ToggleElement implements OnInit {
    @Input() checked: boolean;

    @Input() disabled: boolean;

    @Input() color: string;

    @HostBinding('class') get toggleStyle() {
        return {
            'bazis-toggle--checked': this.checked,
            'bazis-toggle--disabled': this.disabled,
        };
    }

    @HostBinding('ariaChecked') get toggleChecked() {
        return this.checked;
    }

    @HostBinding('ariaHidden') get toggleHidden() {
        return this.disabled;
    }

    @HostListener('click') onClick() {
        if (this.lastDrag + 300 < Date.now()) {
            this.checked = !this.checked;
        }
    }

    inputId: string = `toggleId`;

    lastDrag = 0;

    constructor() {}

    ngOnInit(): void {
        this.disabled = this.disabled !== undefined && this.disabled !== false;
        this.checked = this.checked !== undefined && this.checked !== false;
    }
}
